import { GenericForm } from '@neo/blocks/forms/generic-form'
import type { RExternalAppDetails } from 'v2/types/api/settings'
import {
  buildIntegrationConnectionFormConfig,
  type IntegrationFormValues,
} from './integration-connection-form.config'

export type { IntegrationFormValues } from './integration-connection-form.config'

interface IntegrationConnectionFormProps {
  app: RExternalAppDetails
  onSubmit: (values: IntegrationFormValues) => void
}

export const IntegrationConnectionForm = ({ app, onSubmit }: IntegrationConnectionFormProps) => {
  const config = buildIntegrationConnectionFormConfig(app)

  return (
    <GenericForm<IntegrationFormValues>
      id="integration-external-app-form"
      key={app.id}
      className="p-0.5"
      fields={config.fields}
      onSubmit={onSubmit}
      formValidators={{ onSubmit: config.schema }}
      defaultValues={config.defaults}
      includeSubmitButton={false}
    />
  )
}
